/*
包含n个action的type常量标识名称的模块
 */
export const SET_HEAD_TITLE = 'set_head_title' // 设置头部标题
export const RECEIVE_USER = 'receive_user'  // 接收用户信息
export const SHOW_ERROR_MSG = 'show_error_msg' // 显示错误信息
export const RESET_USER = 'reset_user' // 重置用户信息